/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { CardContent } from 'semantic-ui-react'

const NoTopProductsCardContent = () => {
    return (
      <CardContent
        className="card-content"
        css={css`
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999;
            font-style: italic;
            padding: 1rem;
        `}
      >
          Commencez à traiter des commandes pour voir vos meilleures ventes.
      </CardContent>
    )
}

export { NoTopProductsCardContent }
